import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import App from "./App";
import { routePath } from "./lib/links";
import { installNavigation } from "./lib/navigation";

/** Hydrate the requested static route, then keep the document during clicks. */
export default function BrowserApp() {
  const [path, setPath] = useState(() => routePath(window.location.pathname));
  useEffect(
    () => installNavigation((next) => flushSync(() => setPath(next))),
    [],
  );
  return <App path={path} />;
}
